__turbopack_context__.v({
  "className": "geist_mono_7d6154f0-module__zK-ooG__className",
});
